import React from 'react';
import { Button } from '../../components/widgets';
import withTranslate from '../../containers/widgets/withTranslate';
import ExternalLink from '../../resources/icons/externalLink.svg';
import css from './PlanDetailsButton.css';

const PLAN_DETAILS_URL = 'https://www.singular.net/pricing/#plan-comparison';

const PlanDetailsButton = () => (
    <Button
        type="flat"
        text="STATIC.PAGES.ACCOUNT_PLAN.BUTTONS.PLAN_DETAILS"
        Icon={ExternalLink}
        iconLocation="right"
        className={css.button}
        contentClass={css.content}
        iconClass={css.icon}
        onClick={() => window.open(PLAN_DETAILS_URL, '_blank')}
    />
);

export default withTranslate(PlanDetailsButton);
